import Vue from 'vue';

const AmplifyEventBus = new Vue();

export default AmplifyEventBus;
